module.exports={
  "_args": [
    [
      "make-fetch-happen@3.0.0",
      "C:\\Projects\\TBF\\Source"
    ]
  ],
  "_from": "make-fetch-happen@3.0.0",
  "_id": "make-fetch-happen@3.0.0",
  "_inBundle": true,
  "_integrity": "sha512-FmWY7gC0mL6Z4N86vE14+m719JKE4H0A+pyiOH18B025gF/C113pyfb4gHDDYP5cqnRMHOz06JGdmffC/SES+w==",
  "_location": "/npm/npm-registry-fetch/make-fetch-happen",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "make-fetch-happen@3.0.0",
    "name": "make-fetch-happen",
    "escapedName": "make-fetch-happen",
    "rawSpec": "3.0.0",
    "saveSpec": null,
    "fetchSpec": "3.0.0"
  },
  "_requiredBy": [
    "/npm/npm-registry-fetch"
  ],
  "_resolved": "https://registry.npmjs.org/make-fetch-happen/-/make-fetch-happen-3.0.0.tgz",
  "_shasum": "7b661d2372fc4710ab5cc8e1fa3c290eea69a961",
  "_spec": "3.0.0",
  "_where": "C:\\Projects\\TBF\\Source",
  "author": {
    "name": "Kat Marchán",
    "email": "kzm@sykosomatic.org"
  },
  "bugs": {
    "url": "https://github.com/zkat/make-fetch-happen/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "agentkeepalive": "^3.4.1",
    "cacache": "^10.0.4",
    "http-cache-semantics": "^3.8.1",
    "http-proxy-agent": "^2.1.0",
    "https-proxy-agent": "^2.2.0",
    "lru-cache": "^4.1.2",
    "mississippi": "^3.0.0",
    "node-fetch-npm": "^2.0.2",
    "promise-retry": "^1.1.1",
    "socks-proxy-agent": "^3.0.1",
    "ssri": "^5.2.4"
  },
  "deprecated": false,
  "description": "Opinionated, caching, retrying fetch client",
  "devDependencies": {
    "bluebird": "^3.5.1",
    "mkdirp": "^0.5.1",
    "nock": "^9.2.3",
    "npmlog": "^4.1.2",
    "nyc": "^11.4.1",
    "require-inject": "^1.4.2",
    "rimraf": "^2.6.2",
    "safe-buffer": "^5.1.1",
    "standard": "^11.0.0",
    "standard-version": "^4.3.0",
    "tacks": "^1.2.6",
    "tap": "^11.1.2",
    "weallbehave": "^1.0.0",
    "weallcontribute": "^1.0.7"
  },
  "files": [
    "*.js",
    "lib"
  ],
  "homepage": "https://github.com/zkat/make-fetch-happen#readme",
  "keywords": [
    "http",
    "request",
    "fetch",
    "mean girls",
    "caching",
    "cache",
    "subresource integrity"
  ],
  "license": "ISC",
  "main": "index.js",
  "name": "make-fetch-happen",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/zkat/make-fetch-happen.git"
  },
  "scripts": {
    "postrelease": "npm publish && git push --follow-tags",
    "prerelease": "npm t",
    "pretest": "standard",
    "release": "standard-version -s",
    "test": "nyc --all -- tap --timeout=35 -J test/*.js",
    "update-coc": "weallbehave -o . && git add CODE_OF_CONDUCT.md && git commit -m 'docs(coc): updated CODE_OF_CONDUCT.md'",
    "update-contrib": "weallcontribute -o . && git add CONTRIBUTING.md && git commit -m 'docs(contributing): updated CONTRIBUTING.md'"
  },
  "version": "3.0.0"
}
